module.exports = __webpack_public_path__ + "media/header-video.6554a1ad.mp4";